module.exports = __webpack_public_path__ + "static/case-4-0331ec23a07b1222f9db900f06414bfa.jpg";